import { SITE } from "@/data/site";

export const buildWhatsAppUrl = (message) => {
  const text = encodeURIComponent(message || SITE.whatsapp.defaultMessage);
  return `https://wa.me/${SITE.whatsapp.number}?text=${text}`;
};

export const openWhatsApp = (message) => {
  window.open(buildWhatsAppUrl(message), "_blank", "noopener,noreferrer");
};
